<template lang="pug">
  .crud
    modal-purchase-requisitions-prop(:id="currentId")
    modal-import(model="purchase_requisitions" :title="$t('front.import_modal', {model: $t('strings.purchase_requisitions')})")
    .container-fluid
      vm-row.heading(vm-w="12")
        img(src="@/assets/banner.jpg" width="600")
      vm-row(vm-w="12")
        vm-col(vm-type="flex" vm-align="center" vm-lg=6 vm-sm=6)
          div
            h2 {{ $t('strings.purchase_requisitions') }}:
            span {{ $t('strings.description', {attribute: $t('strings.purchase_requisitions')}) }}
          div(style="display:none;")
            vm-button(type="default" icon="list")
            vm-button(type="default" icon="grid" color="rgba(var(--gray),1)")
        vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-lg=6 vm-sm=6)
          div
            //-vm-button(icon="plus" @click="addPurchaseRequisition") {{ $t('strings.add') }}
            //- vm-tooltip(:text="$t('strings.options')" delay=".5s")
            //-   vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
            //-     vm-button(type="border" icon="more-horizotnal" color="#afbbc6")

            //-     vm-dropdown-menu
            //-       vm-dropdown-item.d-flex.justify-content-between(@click="printReport")
            //-         vm-icon(icon="printer-outline")
            //-         slot &nbsp;{{ $t('strings.print') }}
            //-       vm-dropdown-item.d-flex.justify-content-between(@click="deletePurchaseRequisitionsConfirm" :disabled="!enabledDelete")
            //-         vm-icon(icon="trash-2-outline")
            //-         slot &nbsp;{{ $t('strings.delete') }}
            //-       vm-dropdown-item.d-flex.justify-content-between(@click="setModalImportVisible(true)")
            //-         vm-icon(icon="upload-outline")
            //-         slot &nbsp;{{ $t('strings.import') }}
                  //- More options
                      Agrega mas acciones para colecciones de datos
      vm-row(vm-w="12")
        vm-col.card(vm-sm=12)
          vm-table(multiple v-model="selected"  max-height="350px" :data="purchaseRequisitions")
            template(slot="header")
              .d-flex.justify-content-between
                vm-input(icon="search" size="small" :placeholder="$t('strings.search')" v-model="filters.where.param" @keyup.enter="applyFilter(filters)")
                div
                  vm-select(:placeholder="$t('strings.order_by')" autocomplete width="300px" v-model="filters.orderBy" @change="applyFilter(filters)" size="small")
                    div(v-for="(item,index) in columns")
                      vm-select-item(:key="item + ',asc'" v-if="item !== ''" :value="item + ',asc'" :text="$t('purchase_requisitions.'+ item) + ', asc'")
                      vm-select-item(:key="item + ',desc'" v-if="item !== ''" :value="item + ',desc'" :text="$t('purchase_requisitions.'+ item) + ', desc'")
                  vm-tooltip(:text="$t('strings.filters')" delay=".5s")
                    vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                      vm-button(type="default" icon="funnel-outline" size="small")

                      vm-dropdown-menu(class="filters")
                        .heading.d-flex.justify-content-between
                          h4 {{ $t('strings.filters') }}
                          vm-button(type="flat" size="small" @click="clearFilter") {{ $t('strings.clear') }}
                        vm-select.filter(v-if="$auth.check('Admin')" url="Users" column="name" :placeholder="$t('strings.multiple')" multiple autocomplete :label="$t('purchase_requisitions.user_id')" v-model="filters.whereIn.user_id" @input-change="autoCompleteFunc")
                          vm-select-item(:key="index" :value="item.id" :text="item.name" v-for="(item,index) in purchaseRequisitionsCatalog.users")
                        vm-date-picker.filter(type="daterange" :label="$t('strings.created_at')" :placeholder="$t('strings.select_date')" @on-change="handleChange" :value="filters.betweenDates.created_at")
                        //- Add filters
                            Agrega los filtros que prefieras por ejemplo:
                            vm-select.filter(:placeholder="$t('strings.multiple')" multiple autocomplete label="Status" v-model="filters.whereIn.status")
                              vm-select-item(:key="index" :value="item.value" :text="item.text" v-for="(item,index) in status")
                            vm-select.filter(url="customers" column="tradename" :placeholder="$t('strings.multiple')" multiple autocomplete :label="$t('sales.customer_id')" v-model="filters.whereIn.customer_id" @input-change="autoCompleteFunc")
                              vm-select-item(:key="index" :value="item.id" :text="item.tradename" v-for="(item,index) in revenuesCatalog.customers")
                            vm-date-picker.filter(type="daterange" :label="$t('revenues.created_at')" :placeholder="$t('strings.select_date')" @on-change="handleChange" :value="filters.betweenDates.created_at")

                            NOTA: (agregar clase .filter)
                        .filter.d-flex
                          vm-button(@click="applyFilter(filters)") {{ $t('strings.apply') }}
            template(slot="thead")
              vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('purchase_requisitions.' + column) }}
            template(slot-scope="{data}")
              vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                  slot(v-if="column == 'amount'")  {{data[indextr][column] | currency }}
                  slot(v-if="column != 'amount'") {{data[indextr][column]}}
                vm-td
                  vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                    vm-button(type="flat" icon="more-horizotnal" color="#afbbc6")

                    vm-dropdown-menu
                      vm-dropdown-item.d-flex.justify-content-between(@click="printRecord(data[indextr])")
                        vm-icon(icon="printer-outline")
                        slot &nbsp;{{ $t('strings.print') }}
          vm-pagination(:total="pagination.totalPages" v-model="currentPage" goto)
          transition(name="enter")
            .total-records(v-if="amount>0") Amount: {{ amount | currency }}
    footer-controlla
</template>

<script>
import parseDeleteMany from '@/utils/parseDeleteMany'
import FooterControlla from '@/components/FooterControlla.vue'
import ModalImport from '@/components/modals/ModalImport.vue'
import ModalPurchaseRequisitionsProp from '@/components/modals/ModalPurchaseRequisitionsProp.vue'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('PurchaseRequisitions')

export default {
  name: 'PurchaseRequisitions',
  components: {
    ModalImport,
    FooterControlla,
    ModalPurchaseRequisitionsProp
  },
  data: () => ({
    currentPage: 1,
    currentId: 1,
    selected: [],
    enabledDelete: false,
    columns: [
      'amount',
      'shipping_cost',
      'name',
      'created_at'
    ],
    status: [
      // Agregar los estatus si maneja
      // {
      //   text: 'Pagado',
      //   value: 2,
      //   color: 'warning'
      // }
    ],
    filters: {
      // Nota: Estos campos se parsearan en el v-model de los filtros. Ver linea 60
      where: {
        amount: '',
        param: ''
      },
      whereIn: {
        user_id: []
      },
      whereBetween: {
        // Agrega las columnas que se filtraran entre paramentros ejemplo: priece: []
      },
      betweenDates: {
        created_at: []
      },
      includes: '', // Relationships
      orderBy: ''
    }
  }),
  async created () {
    this.currentPage = this.pagination.currentPage
    await this.getPurchaseRequisitions(this.currentPage)
    this.getCatalog()
  },
  methods: {
    ...mapActions([
      'deletePurchaseRequisition',
      'deletePurchaseRequisitions',
      'loadPurchaseRequisitions',
      'printReportRecord',
      'loadCatalog',
      'actionPurchaseRequisition',
      'setModalImportVisible',
      'setModalPropVisible',
      'printReport',
      'applyFilter',
      'clearFilter'
    ]),
    colorStatus (code) {
      return this.status.find(e => e.value === parseInt(code))['color']
    },
    addPurchaseRequisition () {
      this.$router.push({ name: 'newPurchaseRequisition', params: { isAdd: true } })
    },
    editPurchaseRequisition (purchaseRequisition, index) {
      let id = purchaseRequisition.id
      this.$router.push({ name: 'editPurchaseRequisition', params: { id } })
    },
    async deletePurchaseRequisitionConfirm (purchaseRequisition) {
      let t = this
      this.auxDeletePurchaseRequisition = () => {
        t.deletePurchaseRequisition(purchaseRequisition).then(() => { t.selected = [] })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.purchase_requisition'), attribute: this.$t(purchaseRequisition.amount) }),
        accept: this.auxDeletePurchaseRequisition
      })
    },
    async deletePurchaseRequisitionsConfirm () {
      let t = this
      let purchaseRequisitionsMany = parseDeleteMany(this.selected, 'amount')
      this.auxDeletePurchaseRequisition = () => {
        t.deletePurchaseRequisitions(purchaseRequisitionsMany).then(() => { t.selected = [] })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.purchase_requisition'), attribute: purchaseRequisitionsMany.values }),
        accept: this.auxDeletePurchaseRequisition
      })
    },
    async setActionPurchaseRequisition (record, action) {
      record.id && this.actionPurchaseRequisition({ id: record.id, action })
    },
    async getPurchaseRequisitions (page) {
      this.loadPurchaseRequisitions({ page })
    },
    async getCatalog () {
      Object.keys(this.purchaseRequisitionsCatalog).forEach(e => this.loadCatalog({ url: e, filter: '' }))
    },
    printRecord (record) {
      this.printReportRecord({ id: record.id })
    },
    autoCompleteFunc (value) {
      let payload = {}
      let column = value.target.parentElement.parentElement.getAttribute('column')
      let param = value.srcElement.value
      payload.url = value.target.parentElement.parentElement.getAttribute('url')
      payload.filter = `?${column}=${param}*&order_by=${column},asc`
      this.loadCatalog(payload)
    },
    newObjectFuncModal (value) {
      //
    },
    newObjectFuncView (value) {
      //
    },
    handleChange (date) {
      this.filters.betweenDates.created_at = date
    }
  },
  computed: {
    ...mapGetters([
      'purchaseRequisitions',
      'purchaseRequisitionsCatalog',
      'pagination',
      'filterParams'
    ]),
    amount () {
      return this.selected.reduce((prev, cur) => prev + parseFloat(cur.amount), 0).toFixed(2)
    }
  },
  watch: {
    currentPage (currentPage) {
      this.getPurchaseRequisitions(currentPage)
    },
    filterParams (filter) {
      filter.length === 0 && (this.filters = {
        where: {
          amount: '',
          param: ''
        },
        whereIn: {
          user_id: []
        },
        whereBetween: {
          // Agrega las columnas que se filtraran entre paramentros ejemplo: priece: []
        },
        betweenDates: {
          created_at: []
        },
        includes: '', // Relationships
        orderBy: ''
      })
      this.selected = []
      this.currentPage = 1
      filter.length === 0 && this.applyFilter(this.filters)
      this.getPurchaseRequisitions(this.currentPage)
    },
    selected (selected) {
      this.enabledDelete = selected.length > 0
    }
  }
}
</script>

<style lang="scss" scoped>
.crud {
  padding-top: 134px !important;
}
.heading {
  display: block !important;
  text-align: center;
  margin: 0 !important;
  padding: 0 !important;
}
.filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
  }
}
.con-vm-tooltip {
  display: inline-block;
  position: relative;
}
.vm-table--header {
  padding: 10px;
  span {
    width: 100%;
    .justify-content-between {
      div:last-child {
        .vm-button {
          margin: 0 3px;
        }
        .vm-con-dropdown {
          float: left;
        }
        .con-select {
          display: inline-block;
          input {
            height: 32px;
          }
        }
      }
    }
  }
}
</style>
